
import BreadcrumbView from "../common/breadcrumb/breadcrumb.html";
import RazorViewsListView from "./razor_views-list.html";
import RazorViewsEditView from "./razor_views-edit.html";

angular.module("razor_views", [])

    .config(['$stateProvider', function ($stateProvider) {
        $stateProvider
            .state('razor_views', {
                url: "/razor_views",
                abstract: true,
                controller: "BreadcrumbCtrl",
                template: BreadcrumbView,
            })
            .state('razor_views.list', {
                url: "/list",
                controller: "RazorViewsListCtrl",
                template: RazorViewsListView,
                params: { reset: null },
                data: { pageTitle: 'Vistas' }
            })
            .state('razor_views.edit', {
                url: "/edit/:id",
                controller: "RazorViewsEditCtrl",
                template: RazorViewsEditView,
                data: { pageTitle: 'Vistas' }
            })
        ;
    }])
;
